import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router"
import { CartCheckout } from "../../components/buyer-sales/product-list/CartDrawerCheckout"
import { TableFrame } from "../../components/delivery/atoms"
import { PageLayout } from "../../components/layout"
import { usePermission } from "../../components/permission"
import { DeniedCard, ListState } from "../../components/ui"
import type { ICart } from "../../store/Cart"

/** Checkout page (canvas OrdB_Checkout, B23): the cart drawer's «Захиалга үргэлжлүүлэх» lands here. */
export function BuyerSalesCheckout() {
  const { t } = useTranslation(["order", "common"])
  const navigate = useNavigate()
  const ORD_LIST = usePermission("ORD_LIST")
  const items = useSelector((state: { cart: ICart }) => state.cart.items)

  const breadcrumb = [
    { to: "/", label: t("common:breadcrumb.home") },
    { to: "/buyer-sales/new", label: t("order:catalog.title") },
    { to: "/buyer-sales/new", label: t("order:cart.title") },
    { label: t("order:cart.checkout.breadcrumb") },
  ]
  const title = t("order:cart.checkout.title")

  if (!ORD_LIST.hasAccess) {
    return (
      <PageLayout title={title} breadcrumb={breadcrumb} noFrame>
        <DeniedCard permission="ORD_LIST" />
      </PageLayout>
    )
  }

  if (items.length === 0) {
    return (
      <PageLayout title={title} breadcrumb={breadcrumb} noFrame>
        <TableFrame>
          <ListState
            state="empty"
            title={t("order:cart.emptyTitle")}
            description={t("order:cart.emptyText")}
            action={{ label: t("order:cart.emptyAction"), onClick: () => navigate("/buyer-sales/new") }}
          />
        </TableFrame>
      </PageLayout>
    )
  }

  return (
    <PageLayout title={title} breadcrumb={breadcrumb} noFrame>
      <CartCheckout items={items} />
    </PageLayout>
  )
}
